import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

export const ReConsentBanner = () => {
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(false);
  const [hidden, setHidden] = useState(() => {
    try { return sessionStorage.getItem("ml-reconsent-later") === "1"; } catch { return false; }
  });

  useEffect(() => {
    api.get("/profile/me").then(({ data }) => setInfo(data)).catch(() => {});
  }, []);

  if (hidden || !info || !info.needs_terms_acceptance) return null;

  const accept = async () => {
    setBusy(true);
    try {
      await api.post("/profile/accept-terms", {
        accepted_terms: true,
        terms_version: info.terms_version_current,
      });
      setInfo({ ...info, needs_terms_acceptance: false });
    } catch (e) {
      console.error("Terms acceptance failed:", e);
    } finally { setBusy(false); }
  };

  const later = () => {
    try { sessionStorage.setItem("ml-reconsent-later", "1"); } catch { /* ignore */ }
    setHidden(true);
  };

  return (
    <div className="w-full border-b px-3 py-2 flex flex-wrap items-center gap-2 text-[11px]"
      style={{ background: "rgba(245, 158, 11, 0.08)", borderColor: "rgba(245, 158, 11, 0.35)" }}
      data-testid="reconsent-banner">
      <span style={{ color: "var(--hoip-text-secondary)" }}>
        We've updated our{" "}
        <Link to="/legal/terms" className="underline text-amber-400" data-testid="reconsent-terms-link">Terms of Service</Link>,{" "}
        <Link to="/legal/privacy" className="underline text-amber-400" data-testid="reconsent-privacy-link">Privacy Policy</Link>{" "}
        and related disclosures (version {info.terms_version_current}). Please review and accept the updated terms.
      </span>
      <div className="flex items-center gap-2 ml-auto">
        <button onClick={accept} disabled={busy}
          className="px-2.5 h-6 text-[10px] font-bold rounded-sm bg-amber-500 text-black hover:bg-amber-400 disabled:opacity-50"
          data-testid="reconsent-accept-btn">
          {busy ? "Saving…" : "I've reviewed — Accept"}
        </button>
        <button onClick={later}
          className="px-2 h-6 text-[10px] rounded-sm border hover:bg-[#1A1A1A]"
          style={{ borderColor: "var(--hoip-border)", color: "var(--hoip-text-tertiary)" }}
          data-testid="reconsent-later-btn">
          Later
        </button>
      </div>
    </div>
  );
};
